// extracted by mini-css-extract-plugin
export const homeClients = "HomeClients-module--home-clients--3A5my";
export const homeClientsContainer = "HomeClients-module--home-clients-container--3yk8Z";
export const homeClients__button = "HomeClients-module--home-clients__button--3I7hu";
export const homeClients__logoWrapper = "HomeClients-module--home-clients__logo-wrapper--MfB6P";
export const homeClients__logo = "HomeClients-module--home-clients__logo--MoWBv";
export const homeClientBlur = "HomeClients-module--home-client-blur--lLQFH";
export const homeClientVisible = "HomeClients-module--home-client-visible--1yhKP";